var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signature-wrapper"},[_c('canvas',{staticClass:"signature-canvas",attrs:{"id":'signature_'+_vm._uid,"width":"720","height":"300"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-small btn-light",attrs:{"type":"button"},on:{"click":function($event){_vm.clear()}}},[_vm._v("\n        Clear\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ae01a4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SignatureComponent.vue
// module id = cGwb
// module chunks = 0